































































// decoradores
import { Component, Vue, Prop, Emit } from "vue-property-decorator";
import { Ingreso } from "@/typings/store/plugins/easyFirestore/ingresos";
import SVGIcon from "@/components/SVGIcon.vue";
// tipos

// tipos
@Component({
  components: {
    SVGIcon,
  },
})
export default class InfoIngreso extends Vue {
  @Prop() readonly ingreso!: Ingreso;
  @Prop({ type: Boolean }) readonly showTitulo!: boolean;

  get id(): string {
    return this.ingreso.id || "N/R";
  }

  get nombre(): string {
    return this.ingreso.nombre || "N/R";
  }

  get posicion(): string {
    return this.ingreso.posicion || "N/R";
  }


  @Emit("cerrar")
  onCerrar(): void {
    return;
  }
}
